// extracted by mini-css-extract-plugin
export var questionBox = "_72-0";